import { Pipe, PipeTransform } from '@angular/core';

/**
 * 將10以內的數字轉為中文的pipe
 * ex. 3 -> 三
 */
@Pipe({
  name: 'numberToChinese',
  standalone: true,
})
export class NumberToChinesePipe implements PipeTransform {
  transform(value: number): string {
    if (isNaN(value) || value > 10 || value < 0) return '';

    const chineseNumbers = [
      '零',
      '一',
      '二',
      '三',
      '四',
      '五',
      '六',
      '七',
      '八',
      '九',
      '十',
    ];
    return chineseNumbers[value];
  }
}
